// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3hNg6","header":"ClearentDisclaimer_header__2zhHV","inner":"ClearentDisclaimer_inner__27SP7"};